var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.989 4.814c0-.564-.457-1.024-1.02-1.024h-5.307V2.414a1.41 1.41 0 0 0-1.407-1.413L8.745 1c-.777 0-1.408.634-1.408 1.413V3.79H2.03c-.562 0-1.019.46-1.019 1.023L1 9.682c0 .158.09.302.231.371.216.105.44.203.662.3v6.623c0 .564.457 1.024 1.02 1.024h15.175c.561 0 1.019-.459 1.019-1.024v-6.723c.228-.107.455-.217.675-.333A.412.412 0 0 0 20 9.555l-.011-4.741zm-11.833-2.4a.59.59 0 0 1 .588-.59h3.51c.32 0 .588.27.588.59V3.79H8.156V2.414zm10.13 14.562c0 .106-.093.2-.2.2H2.913a.203.203 0 0 1-.2-.2v-6.299c1.783.658 3.774 1.052 5.946 1.173v.57a.75.75 0 0 0 .747.751h2.19a.75.75 0 0 0 .746-.75v-.577c2.2-.134 4.192-.551 5.946-1.242v6.374zm-8.81-4.627v-1.365h2.046v1.365H9.477zm2.865-1.332v-.104a.75.75 0 0 0-.747-.751h-2.19a.75.75 0 0 0-.746.75v.114c-2.565-.148-4.864-.684-6.838-1.604l.01-4.609c0-.108.091-.2.2-.2h16.94c.108 0 .2.091.2.201l.01 4.49c-1.926.975-4.227 1.548-6.838 1.713h0z",
    fill: "#717375",
    stroke: "#717375",
    strokeWidth: 0.25
  })));
}

export default SvgJob;